import React, { useEffect } from 'react'
import { formatDate } from '@progress/kendo-intl';
import {
    getSelectedState,
    Grid,
    GridColumn,
    GridSelectionChangeEvent,
    GridSortChangeEvent,
    //GridDetailExpandChangeEvent,
    GridDetailRowProps
} from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";
import { GridCellProps } from '@progress/kendo-react-grid';
import { Link } from 'react-router-dom';
import { TextBox, Checkbox } from '@progress/kendo-react-inputs';
import {
    filterBy, orderBy, SortDescriptor
} from "@progress/kendo-data-query";
import { Api, useGetTenantQuery } from '../../../redux/api/BaseApi';
import { getTicketStateClassName } from '../../../utils/utils';
import { TicketGridProps } from '../../../types/Props/TicketGridProps';
//import { DetailExpandDescriptor } from '@progress/kendo-react-data-tools';

const TicketGrid = (props: TicketGridProps) => {
    const { data: profile } = Api.useGetUserProfileQuery();
    const DATA_ITEM_KEY = "ID";
    const idGetter = getter(DATA_ITEM_KEY);
    const SELECTED_FIELD = "selected";
    const { data: userProfile } = Api.useGetUserProfileQuery();
    const [filter, setFilter] = React.useState(null);
    const [gridData, setGridData] = React.useState(null);
    const [putAtTop, setPutAtTop] = React.useState(false);
    const { data: tenant } = useGetTenantQuery()

    //const [detailExpand, setDetailExpand] = React.useState<DetailExpandDescriptor>({ 2: true });

    //put the selected ticket at the top of the grid
    React.useEffect(() => {
        let sortedTickets = props.data?.slice().sort((a, b) => a.ID - b.ID);
        if (props.selectedTicketId) {
            let selectedTicket = sortedTickets.find(x => x.ID === props.selectedTicketId);
            console.warn('usedEffect', props.selectedTicketId, selectedTicket);
            if (selectedTicket && !putAtTop) {
                let retGridData = props.data?.filter(x => x.ID !== props.selectedTicketId);
                retGridData.unshift(selectedTicket);
                console.warn('usedMemo unshift', 'top', retGridData.length && retGridData[0].ID);
                setGridData(retGridData);
                setPutAtTop(true);
                return;
            }
        }
        setGridData(sortedTickets);
    }, [props])

    //console.warn('gridData', gridData.length && gridData[0].ID, props.selectedTicketId);

    let primaryCol = props.primaryCol ? props.primaryCol : "Company_Name";
    //Sorting
    const initialSort: Array<SortDescriptor> = [
        //{ field: SELECTED_FIELD, dir: "desc" },
        //{ field: "Call_Id", dir: "desc" },

    ];
    const [sort, setSort] = React.useState(initialSort);

    ///Fires when a ticket is selected in the Grid
    const ticketSelected = (e) => {
        //console.log('TicketGrid',e);
        if (e.checked)
            props.onTicketSelected(e.value)
        else
            props.onTicketSelected(0)

        setSelectedState({ [e.value]: e.checked });
    }
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({ [props.selectedTicketId]: true });
    const ticketRowSelected = (event: GridSelectionChangeEvent) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "ID",
        });

        setSelectedState(newSelectedState);

        props.onTicketSelected(event.dataItems[event.startRowIndex].ID);
    }
    const filterChanged = (e) => {
        console.log('filterchanged', e.value)
        let newFilter = {
            logic: "or",
            filters: [
                { field: "Call_Status", operator: "contains", value: e.value },
                { field: "Company_Name", operator: "contains", value: e.value },
                { field: "Project_Name", operator: "contains", value: e.value },
                { field: "Call_Desc", operator: "contains", value: e.value },
                { field: "ID", operator: "contains", value: e.value },
            ],
        }
        setFilter(newFilter);
    }

    useEffect(() => {

        setSelectedState({ [props.selectedTicketId]: true });
    }, [props.selectedTicketId])

    const subGrid = (gridprops: GridDetailRowProps) => {
        if (gridprops.dataItem[SELECTED_FIELD] && props.subGridData)
            //return <>{props.subGridData?.length?.toString()}</>
            return <>
                {props.subGridHeader && <h6>{props.subGridHeader}</h6>}
                <TicketGrid {...props} data={props.subGridData} subGridData={null} selectedTicketId={props.selectedTicketId} selectable={false} primaryCol={primaryCol} showFilters={false} /></>

        //return gridprops.dataItem["expanded"] ? 'expanded' : 'collapsed';
    }
    return (
        <>
            {props.showFilters !== false &&
                <div className="flex w-full mb-3">
                    <TextBox style={{ width: '70%' }} type={"text"} onChange={filterChanged} placeholder={`Filter by: #, Description, ${profile?.Phrases.Client}, ${profile?.Phrases.Project} or Status`} />
                </div>}
            <Grid className='ticket-grid'
                onSelectionChange={ticketRowSelected}
                detail={props.subGridData && subGrid}
                expandField={SELECTED_FIELD}
                sortable={true}
                sort={sort}
                onSortChange={(e: GridSortChangeEvent) => {
                    setSort(e.sort);
                }}
                selectable={{
                    enabled: props.selectable
                }}
                selectedField={SELECTED_FIELD}
                data={orderBy(
                    filterBy(gridData?.slice().map((item) => ({
                        ...item,
                        [SELECTED_FIELD]: selectedState[idGetter(item)],
                        ['expanded']: true
                    })), filter),
                    sort)}
            >
                {props.selectable &&
                    <GridColumn width="40px" sortable={false}
                        cells={{
                            data: (props: GridCellProps) => {
                                let fieldValue = props.dataItem["ID"] || "";
                                return (
                                    <>
                                        <td className='chk'>
                                            <Checkbox radioGroup="ticket" value={fieldValue} checked={props.dataItem[SELECTED_FIELD]} onChange={(e) => { e.syntheticEvent.preventDefault(); ticketSelected({ value: fieldValue, checked: e.value }) }} />
                                        </td>
                                    </>
                                );
                            }
                        }}
                    />}

                <GridColumn field="ID" title={`${userProfile.Phrases.CallPhrase} #`} width="80px"
                    cell={(props: GridCellProps) => {
                        let fieldValue = props.dataItem[props.field] || "";
                        return (
                            <td className={getTicketStateClassName(props.dataItem["Call_State"])}>
                                <Link className='ticket-link'
                                    //target={"_blank"}
                                    //to={`${tenant?.Tenant_Url}/calls/callhistory.aspx?call_id=${fieldValue}`}
                                    to={`/ticket/${fieldValue}`}
                                >{fieldValue}</Link>
                            </td>
                        );
                    }}
                />
                <GridColumn title="Opened" width="100px" cell={(props: GridCellProps) => {
                    return (
                        <td onClick={() => ticketSelected({ value: props.dataItem["ID"], checked: true })}>
                            {formatDate(new Date(props.dataItem["Open_Dt"] + 'Z'), "g")}
                        </td>
                    );
                }} />
                <GridColumn field={primaryCol} title={`${userProfile.Phrases.Client} / ${userProfile.Phrases.Project}`}
                    cell={(props: GridCellProps) => {
                        return (
                            <td onClick={() => ticketSelected({ value: props.dataItem["ID"], checked: true })}>
                                <b>{props.dataItem[primaryCol]}</b>
                                <div>{props.dataItem["Project_Name"]}</div>
                            </td>
                        );
                    }}
                />
                <GridColumn field="Call_Desc" title="Description" />
                <GridColumn field="Call_Status" title="Status" width={150} />
            </Grid>
        </>
    )
}

export default TicketGrid